module.exports = __webpack_public_path__ + "img/22t.prt.da7eb736.jpg";